/*
  stuff that happens on many attributes across the whole map or a batch of cards
*/
class BulkAttributesUI {
  setCanvas(canvas) {
    this.canvas = canvas;
  }

  addAttribute({ role='card', name, value, nodeIds }) {
    if (!nodeIds || !nodeIds.length) return;
    const operationMessages = [];
    for (const nodeId of nodeIds) {
      const node = this.canvas.store.getNode(nodeId);
      if (node.getAttributeByValue({role, name, value})) {
        continue;
      }
      const attrId = node.addAttribute({ role, name, value });
      this.updateNode(nodeId);
      if (attrId) {
        const message = this.canvas.operation.messages.addMapNodeAttribute({
          uuid: attrId,
          mapNodeUUID: nodeId,
          role,
          name,
          value,
        });
        operationMessages.push(message);
      } else {
        console.log(`addAttribute ${role}:${name}:${value} failed`);
      }
    }
    this.updateSidebar();
    this.canvas.operation.batchOperation({
      messages: operationMessages,
      onFailure: (err) => {
        console.log(`addAttribute batchOperation operation failed: ${err}`);
      }
    });
  }

  removeAttributesByName({ role='card', name }) {
    const operationMessages = [];

    this.canvas.store.getNodesArray().forEach(node => {
      const attr = node.getAttributeByName({ name });
      if (attr) {
        node.removeAttribute({ role, id: attr.id });
        operationMessages.push(
          this.canvas.operation.messages.removeMapNodeAttribute({
            uuid: attr.id,
            mapNodeUUID: node.id,
            name: attr.name,
            value: attr.value,
            role
          })
        );
        this.updateNode(node.id);
      }
    });
    this.updateSidebar();

    this.canvas.operation.batchOperation({
      messages: operationMessages,
      onFailure: (err) => {
        console.log(`removeAttributesByNamebatchOperation operation failed: ${err}`);
      }
    });
  }

  removeAttributesByValue({ role='card', name, value }) {
    const operationMessages = [];

    this.canvas.store.getNodesArray().forEach(node => {
      const attr = node.getAttributeByValue({ name, value });
      if (attr) {
        node.removeAttribute({ role, id: attr.id });
        operationMessages.push(
          this.canvas.operation.messages.removeMapNodeAttribute({
            uuid: attr.id,
            mapNodeUUID: node.id,
            name: attr.name,
            value: attr.value,
            role
          })
        );
        this.updateNode(node.id);
      }
    });
    this.updateSidebar();

    this.canvas.operation.batchOperation({
      messages: operationMessages,
      onFailure: (err) => {
        console.log(`removeAttributesByNamebatchOperation operation failed: ${err}`);
      }
    });
  }



  updateNode(nodeId) {
    const nodeTag = this.canvas.nodeTags[nodeId];
    if (nodeTag) {
      nodeTag.update({ forceUpdate: true });
      const attributesTag = nodeTag.tags['node-attributes'];
      if (attributesTag) {
        attributesTag.update();
      }
      nodeTag.topLevelParentTag().rediscoverLinkPositions();
    }
  }

  updateSidebar() {
    this.canvas.attributesTabTag.update();
  }
}

const baui = new BulkAttributesUI();
export {BulkAttributesUI, baui};



// WEBPACK FOOTER //
// ./starling/src/lib/bulk-attributes-ui.js